module.exports = __webpack_public_path__ + "static/media/undo.52cbb3e3.svg";